import React, { Component } from 'react';
import * as analytics from '../lib/analytics';

import { Text, Link } from 'pp-react';

import content from '../lib/i18n';
const i18n = content('hub/components/stripe');

import glamorous from 'glamorous';
import OverPanel from './OverPanel';
import styles from './stripe.less';

const StripeDiv = glamorous.div({
  padding: '24px 0px 24px 0px',
});

const MessageContainer = glamorous.div({
  textAlign: 'center',
});

const TermLink = glamorous(Text)({
  padding: '5px',
  margin: '0px auto',
  textAlign: 'center',
});

const TermTitle = glamorous(Text)({
  textAlign: 'center',
  margin: '0 auto',
});

const Terms = glamorous.div({
  padding: '30px',
});

const TermOl = glamorous(Text)({
  listStyleType: 'decimal',
});

const TermImage = glamorous.div({
  textAlign: 'center',
  marginBottom: '23px',
});

export default class Stripe extends Component {
  constructor(props) {
    super(props);

    this.handleAnalytics = this.handleAnalytics.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.renderLink = this.renderLink.bind(this);
    this.renderModal = this.renderModal.bind(this);

    this.state = {
      showModal: false,
    };
  }

  handleAnalytics(event) {
    analytics.trackLink(
      event,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );
  }

  handleClick(event) {
    this.setState({ showModal: true });
    this.handleAnalytics(event);
  }

  renderLink() {
    const href = i18n('label.learn-more-link');
    const content = i18n('label.learn-more');
    if (!!href && href !== '/') {
      // normal link to 'learn more content'
      return (
        <Link href={href} onClick={this.handleAnalytics}>
          {content}
        </Link>
      );
    } else if (href) {
      // open a modal to display 'learn more content'
      return (
        <Link data-ppvx_modal-id='stripeTerms' onClick={this.handleClick}>
          {content}
        </Link>
      );
    }
  }

  renderModal() {
    const title = i18n('label.terms-title');
    const termsLink = i18n('label.terms-link');
    let terms = i18n('label.terms');
    if (!Array.isArray(terms)) {
      terms = [];
    }

    const ModalBody = (
      <div style={{ marginTop: '60px' }}>
        <TermImage>
          <img src='https://www.paypalobjects.com/images/Cause/hub/ic_blueheart.svg' />
        </TermImage>
        <TermTitle as='p' id={title} size='xl' regular>
          {title}
        </TermTitle>
        <Terms>
          <TermOl as='ol'>
            {terms.map((term, i) => (
              <li key={i}>
                <Text size='md' dangerouslySetInnerHTML={{ __html: term }} />
              </li>
            ))}
          </TermOl>
        </Terms>
        <TermLink
          as='div'
          dangerouslySetInnerHTML={{
            __html: termsLink,
          }}
        />
      </div>
    );
    return (
      <OverPanel
        titleId={title}
        modalId='stripeTerms'
        renderModalBody={ModalBody}
      />
    );
  }

  render() {
    let message = this.props.message;
    if (!message) {
      message = i18n('label.message');
    }

    return (
      <StripeDiv>
        {this.renderModal()}
        <MessageContainer>
          <Text
            as='p'
            size='xl3'
            className={styles.stripeTerms}
            dangerouslySetInnerHTML={{ __html: message }}
          ></Text>
          {this.props.isPPGF && <TermLink>{this.renderLink()}</TermLink>}
        </MessageContainer>
      </StripeDiv>
    );
  }
}
